import { ReactNode } from "react";
import { VariantProps, tv } from "tailwind-variants";

const styles = tv({
  slots: { base: "!text-mobile-small md:!text-small" },
  variants: {
    color: {
      inherit: "inherit",
      white: "text-white",
      primary: "text-primary",
      secondary: "text-secondary",
    },
  },
  defaultVariants: {
    color: "inherit",
  },
});

interface IProps {
  children: ReactNode;
  color?: VariantProps<typeof styles>["color"];
  className?: string;
  testId?: string;
}

const Small = ({ children, className, color, testId }: IProps) => {
  const { base } = styles({ color, className });

  return (
    <small data-testid={testId} className={base({ className })}>
      {children}
    </small>
  );
};

export default Small;
